var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBagShopping(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M400 160H320V96C320 43.062 276.938 0 224 0S128 43.062 128 96V160H48C30.328 160 16 174.326 16 192V432C16 476.182 51.816 512 96 512H352C396.184 512 432 476.182 432 432V192C432 174.326 417.672 160 400 160ZM144 96C144 51.891 179.875 16 224 16S304 51.891 304 96V160H144V96ZM416 432C416 467.289 387.289 496 352 496H96C60.711 496 32 467.289 32 432V192C32 183.178 39.176 176 48 176H128V248C128 252.422 131.594 256 136 256S144 252.422 144 248V176H304V248C304 252.422 307.594 256 312 256S320 252.422 320 248V176H400C408.824 176 416 183.178 416 192V432Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBagShopping);
export default __webpack_public_path__ + "static/media/bag-shopping.f5b5bbcbd687db0f406988a2d627adf3.svg";
export { ForwardRef as ReactComponent };